import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import styles from './styles/CartEmptyWrapper.scss';

const links = [
    {
        label: (
            <FormattedMessage
                id="CartEmptyWrapper.links.furniture"
                defaultMessage="Browse Furniture"
            />
        ),
        url: '/furniture/',
    },
    {
        label: (
            <FormattedMessage id="CartEmptyWrapper.links.fashion" defaultMessage="Browse Fashion" />
        ),
        url: '/fashion/',
    },
    {
        label: (
            <FormattedMessage
                id="CartEmptyWrapper.links.jewelry"
                defaultMessage="Browse Jewelry & Watches"
            />
        ),
        url: '/jewelry/',
    },
    {
        label: (
            <FormattedMessage id="CartEmptyWrapper.links.art" defaultMessage="Browse Fine Art" />
        ),
        url: '/art/',
    },
];

function CartEmptyWrapper({ children }) {
    return (
        <div className={styles.wrapper}>
            <div className={styles.message} data-tn="cart-empty-message">
                {children}
            </div>
            <div className={styles.linkContainer}>
                {links.map(({ url, label }) => {
                    return (
                        <a key={url} href={url} className={styles.link} data-tn="cart-empty-link">
                            {label}
                        </a>
                    );
                })}
            </div>
        </div>
    );
}

CartEmptyWrapper.propTypes = {
    children: PropTypes.node.isRequired,
};

export default CartEmptyWrapper;
